export class DataBoxRequest {
  constructor(
    CmdType,
    CommandName,
    Params,
    JwtToken,
    ApiKey,
    CommandTimeout,
    ParentColumn,
    ChildColumn,
    Filter
  ) {
    if (CmdType != undefined && typeof CmdType == "number") {
      this.CmdType = CmdType;
    } else {
      this.CmdType = 0;
    }

    if (CommandName != undefined && typeof CommandName == "string") {
      this.CommandName = CommandName;
    } else {
      this.CommandName = "";
    }

    if (Params != undefined && typeof Params == "object") {
      this.Params = Params;
    } else {
      this.Params = null;
    }

    if (JwtToken != undefined && typeof JwtToken == "string") {
      this.JwtToken = JwtToken;
    } else {
      this.JwtToken = "";
    }

    if (ApiKey != undefined && typeof ApiKey == "string") {
      this.ApiKey = ApiKey;
    } else {
      this.ApiKey = "";
    }

    if (CommandTimeout != undefined && typeof CommandTimeout == "number") {
      this.CommandTimeout = CommandTimeout;
    } else {
      this.CommandTimeout = 0;
    }

    if (ParentColumn != undefined && typeof ParentColumn == "string") {
      this.ParentColumn = ParentColumn;
    } else {
      this.ParentColumn = "";
    }

    if (ChildColumn != undefined && typeof ChildColumn == "string") {
      this.ChildColumn = ChildColumn;
    } else {
      this.ChildColumn = "";
    }

    if (Filter != undefined && typeof Filter == "string") {
      this.Filter = Filter;
    } else {
      this.Filter = "";
    }
  }
}
